'use strict';

const STEP_EMAIL_STATUS = {
  BOUNCED: 'bounced',
  AUTOREPLIED: 'autoreplied',
  REPLIED: 'replied',
  CLICKED: 'clicked',
  OPENED: 'opened',
  SENT: 'sent',
};

export {
  STEP_EMAIL_STATUS,
};
